
import { defineComponent } from 'vue';
import BottomNavigation from '../layout/BottomNavigation.vue';

const __default__ = defineComponent({
    components: { BottomNavigation },
    props: {
        headerTitle: { type: String, required: true },
        activeValidate: { type: Boolean, required: true },
        // Harmonisation de la taille avec ModalCard
        maxWidth: { type: String, required: false, default: '60%' },
        // Largeur fixe optionnelle (ex: '70vw' ou '1200px')
        width: { type: String, required: false, default: undefined },
        // Hauteur fixe optionnelle de la carte (ex: '80vh'). Le contenu scrolle à l'intérieur.
        height: { type: String, required: false, default: undefined },
        // Hauteur max du contenu défilant
        contentMaxHeight: { type: String, required: false, default: '25vh' },
        // Overflow du conteneur de contenu (ex: 'visible' pour les dropdowns)
        overflowContent: { type: String, required: false, default: 'auto' },
        // Largeur minimale optionnelle (ex: '900px')
        minWidth: { type: String, required: false, default: '650px' },
        // Afficher ou non le bouton précédent
        first: { type: Boolean, required: false, default: true },
        // Callback du bouton précédent
        back: { type: Function, required: false, default: undefined },
    },
    methods: {
        confirm() {
            this.$emit('confirm');
        },
        cancel() {
            this.$emit('cancel');
        },
    },
    computed: {
        closeIcon() {
            return require('@/assets/img/close-white.svg');
        },
    },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "v68143073": (_ctx.maxWidth),
  "v1d2819b5": (_ctx.width),
  "v0394d776": (_ctx.minWidth),
  "v6e0c2318": (_ctx.height),
  "v0350ff46": (_ctx.overflowContent),
  "f02df83a": (_ctx.contentMaxHeight)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__